




















































import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import IEventBrandingDto from "@/chipply/IEventBrandingDto";
import IEventCategoriesDto from "@/chipply/i-event-categories-dto";
import IEventCategoryDto from "@/chipply/i-event-category-dto";
import { StoreHelper } from "@/chipply/helper/StoreHelper";

@Component({})
export default class CategoryDesktopPanel extends Vue {
    public name = "CategoryDesktopPanel";

    @Prop({ type: Object })
    public branding!: IEventBrandingDto;

    @Prop({ type: Object })
    public categories!: IEventCategoriesDto;

    @Prop({ type: Object })
    public selectedCategory: IEventCategoryDto | null = null;

    private storeHelper = new StoreHelper();

    protected breakCatName(name: string) {
        var copy = name;
        var indices = [0];
        copy = copy.replace(/\s+/g, "i");
        while (/\W/.test(copy)) {
            indices.push(copy.search(/\W/));
            copy = copy.replace(/\W/, "i");
        }
        var modifier = 0;
        indices.forEach((character, index) => {
            if (index > 1) {
                modifier += 5;
                character = character + modifier;
            }
            var startingIndex = indices[index - 1] + modifier;
            var sub = name.substring(startingIndex, character + 1);
            if (index != 0) {
                name = name.replace(sub, sub + "<wbr>");
            }
        });

        return name;
    }

    private get subCategories() {
        var unlocked = this.storeHelper.checkPasswords(this.selectedCategory);
        return unlocked || [];
    }
}
